export const CHANGE_PAGE = 'CHANGE_PAGE';
export const APP_START = 'APP_START';
export const APP_FIND_LESSON = 'APP_FIND_LESSON';

export const TOGGLE_PROFILE = 'TOGGLE_PROFILE';
export const TOGGLE_FEEDBACK = 'TOGGLE_FEEDBACK';
export const APP_SHOW_FEEDBACK_REQUEST = 'APP_SHOW_FEEDBACK_REQUEST';
export const APP_SET_FEEDBACK_SCREENSHOT_BLOB = 'APP_SET_FEEDBACK_SCREENSHOT_BLOB';
export const APP_TOGGLE_STUDENT_CARD = 'APP_TOGGLE_STUDENT_CARD';
export const APP_STUDENT_CARD_IS_DIRTY = 'APP_STUDENT_CARD_IS_DIRTY';

export const APP_ENGLISH_LEVELS_REQUEST = 'APP_ENGLISH_LEVELS_REQUEST';
export const APP_ENGLISH_LEVELS_SUCCESS = 'APP_ENGLISH_LEVELS_SUCCESS';

export const GET_ROLE_DATA_FLOW = 'GET_ROLE_DATA_FLOW';
